<script lang="ts">
    import type { Question } from "../../Model/Question";
    import { getContext } from "svelte";
    import type { GetAnswerFn, OptionState, SaveAnswerFn } from "../../global";
    import type { Answer } from "../../Model/Answer";
    import type { Readable } from "svelte/store";
    import QuestionBox from "./QuestionBox.svelte";
    import Invalidation from "./Invalidation.svelte";
    import AlertSaveError from "../AlertSaveError.svelte";

    export let question: Question;


    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const readonlyForm: Readable<boolean> = getContext('readonlyForm');
    const saveAnswer: SaveAnswerFn = getContext('saveAnswer');

    let isSaving = false;
    let saveError = false;
    let invalidatesForm = false;
    let answer: Answer;
    let value: Readable<any>;
    let options: OptionState[];
    
    $: setupQuestion(question);

    function setupQuestion(question: Question): void {
        answer = getAnswer(question.id);
        value = answer.valueReadable;
        options = question.options.questionOptions;
        updateInvalidationState();
    }


    async function onChange(option: OptionState): Promise<void> {
        if (!answer || $readonlyForm) {
            return;
        }
        try {
            isSaving = true;
            answer.value = option.id;
            updateInvalidationState();
            
            await saveAnswer(answer);
            saveError = false;
        } catch (error) {
            saveError = true;
        } finally {
            isSaving = false;
        }
    }

    function updateInvalidationState() {
        invalidatesForm = !!options.find(({ id }) => id === $value)?.restrict;
    }

</script>

<QuestionBox {question} {isSaving}>

    {#each options as option}
        <div class="form-check">
            <input
                class="form-check-input"
                type="radio"
                disabled={$readonlyForm}
                name={question.id}
                id={`radio-${option.id}`}
                checked={$value === option.id}
                on:change={() => onChange(option)}>
            <label class="form-check-label" for={`radio-${option.id}`}>{option.text}</label>
        </div>
    {/each}

    {#if saveError}
        <AlertSaveError />
    {/if}

    {#if invalidatesForm}
        <Invalidation />
    {/if}

</QuestionBox>

